@if (loginState.toString() !== LoginStateEnum.SignedIn) {
  <app-login [loginState]="loginState"></app-login>
}
@if (loginState.toString() === LoginStateEnum.SignedIn) {
  <app-main [isForceGetSolutionInfo]="isForceGetSolutionInfo"></app-main>
}